import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';


export class F8TimePipe implements PipeTransform {
  transform(value: string) {
    // TODO: add support for weeks
    // const dateObject = moment(value).toObject();
    // const dateArray = moment(value).toArray();
    return moment(value).fromNow();
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'f8Time' }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
